import type { Brand } from "@bmi/payload-types";

export const brands: Brand[] = [
  "AeroDek",
  "BMI",
  "BMIAcademyEN",
  "BMIAcademyDE",
  "BRAAS",
  "BRAMAC",
  "Canopia",
  "Cementegola",
  "ChovA",
  "Cobert",
  "Coverland",
  "Esha",
  "Everguard",
  "Everlite",
  "icopal",
  "icopalKatto",
  "icopalVedag",
  "Klober",
  "Monarflex",
  "Monarplan",
  "MONIER",
  "Necoflex",
  "Ormax",
  "Redland",
  "RoofPro",
  "RoofProServiceTeam",
  "Sealoflex",
  "SereniCoperture",
  "Siplast",
  "Sunscape",
  "VEDAG",
  "VILLAS",
  "Wierer",
  "WOLFIN",
  "Zanda"
];
